"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setReviewsFetchingError = exports.setPreviousBookings = exports.setOfferActionsEnabled = exports.setIsShowBookingForOperatorForm = exports.setIntegrationServices = exports.setFosterLinkOfOffer = exports.setCountries = exports.setBootstrapData = exports.setBookingCompanies = exports.setActiveOutboundFlight = exports.setActiveIntegrationService = exports.setActiveInboundFlight = exports.resetStore = exports.removeReviewsFetchingError = exports.openMap = exports.handleChangeRadius = exports.detachActiveIntegrationService = exports.changeCurrencyCode = exports.bootstrapOfferDetailsPage = exports.bootstrapOfferDetailsModal = exports.bookingOfferByOperator = void 0;
var _reduxActions = require("redux-actions");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _createActions = (0, _reduxActions.createActions)({
    bootstrapOfferDetailsPage: function bootstrapOfferDetailsPage(hotelID, offerID, baseQueryID) {
      return {
        hotelID: hotelID,
        offerID: offerID,
        baseQueryID: baseQueryID
      };
    },
    bootstrapOfferDetailsModal: function bootstrapOfferDetailsModal(hotelID, offerID, baseQueryID, initialCurrencyCode, offerActionsEnabled) {
      return {
        hotelID: hotelID,
        offerID: offerID,
        baseQueryID: baseQueryID,
        initialCurrencyCode: initialCurrencyCode,
        offerActionsEnabled: offerActionsEnabled
      };
    },
    changeCurrencyCode: function changeCurrencyCode(currencyCode, offerID, queryID) {
      return {
        currencyCode: currencyCode,
        offerID: offerID,
        queryID: queryID
      };
    },
    handleChangeRadius: function handleChangeRadius(hotelID, radius) {
      return {
        hotelID: hotelID,
        radius: radius
      };
    },
    openMap: function openMap(hotelID, offerID) {
      return {
        hotelID: hotelID,
        offerID: offerID
      };
    },
    removeReviewsFetchingError: function removeReviewsFetchingError(hotelID) {
      return hotelID;
    },
    setReviewsFetchingError: function setReviewsFetchingError(hotelID) {
      return _defineProperty({}, hotelID, true);
    },
    setBootstrapData: function setBootstrapData(bootstrapData) {
      return bootstrapData;
    },
    bookingOfferByOperator: function bookingOfferByOperator(values, queryID) {
      return {
        values: values,
        queryID: queryID
      };
    },
    setIsShowBookingForOperatorForm: function setIsShowBookingForOperatorForm(isShow) {
      return isShow;
    },
    resetStore: function resetStore() {
      return undefined;
    },
    setCountries: function setCountries(countries) {
      return countries;
    },
    setOfferActionsEnabled: function setOfferActionsEnabled(actions) {
      return actions;
    },
    setActiveOutboundFlight: function setActiveOutboundFlight(flight) {
      return flight;
    },
    setActiveInboundFlight: function setActiveInboundFlight(flight) {
      return flight;
    },
    setFosterLinkOfOffer: function setFosterLinkOfOffer(link) {
      return link;
    },
    setPreviousBookings: function setPreviousBookings(bookings) {
      return bookings;
    },
    setBookingCompanies: function setBookingCompanies(companies) {
      return companies;
    },
    setIntegrationServices: function setIntegrationServices(services) {
      return services;
    },
    setActiveIntegrationService: function setActiveIntegrationService(serviceID) {
      return serviceID;
    },
    detachActiveIntegrationService: function detachActiveIntegrationService(serviceID) {
      return serviceID;
    }
  }, {
    prefix: 'TS_OFFER_DETAILS'
  }),
  bootstrapOfferDetailsPage = exports.bootstrapOfferDetailsPage = _createActions.bootstrapOfferDetailsPage,
  bootstrapOfferDetailsModal = exports.bootstrapOfferDetailsModal = _createActions.bootstrapOfferDetailsModal,
  changeCurrencyCode = exports.changeCurrencyCode = _createActions.changeCurrencyCode,
  handleChangeRadius = exports.handleChangeRadius = _createActions.handleChangeRadius,
  openMap = exports.openMap = _createActions.openMap,
  removeReviewsFetchingError = exports.removeReviewsFetchingError = _createActions.removeReviewsFetchingError,
  setReviewsFetchingError = exports.setReviewsFetchingError = _createActions.setReviewsFetchingError,
  setBootstrapData = exports.setBootstrapData = _createActions.setBootstrapData,
  bookingOfferByOperator = exports.bookingOfferByOperator = _createActions.bookingOfferByOperator,
  resetStore = exports.resetStore = _createActions.resetStore,
  setIsShowBookingForOperatorForm = exports.setIsShowBookingForOperatorForm = _createActions.setIsShowBookingForOperatorForm,
  setCountries = exports.setCountries = _createActions.setCountries,
  setOfferActionsEnabled = exports.setOfferActionsEnabled = _createActions.setOfferActionsEnabled,
  setActiveOutboundFlight = exports.setActiveOutboundFlight = _createActions.setActiveOutboundFlight,
  setActiveInboundFlight = exports.setActiveInboundFlight = _createActions.setActiveInboundFlight,
  setFosterLinkOfOffer = exports.setFosterLinkOfOffer = _createActions.setFosterLinkOfOffer,
  setPreviousBookings = exports.setPreviousBookings = _createActions.setPreviousBookings,
  setBookingCompanies = exports.setBookingCompanies = _createActions.setBookingCompanies,
  setIntegrationServices = exports.setIntegrationServices = _createActions.setIntegrationServices,
  setActiveIntegrationService = exports.setActiveIntegrationService = _createActions.setActiveIntegrationService,
  detachActiveIntegrationService = exports.detachActiveIntegrationService = _createActions.detachActiveIntegrationService;